const MOBILE_CLASS = "mobile";

const handler = () => {
    document.body.classList.toggle(MOBILE_CLASS, window.innerWidth < 768);
}

export const mobileBodyClass = () => {
    window.addEventListener('resize', handler);
    handler();
};